import React from 'react'
import { Alert } from '@material-ui/lab'
import strings from 'strings'

const AccessRequestAlert = ({ type, clientName, clientId, userEmail }) => {
  const accessStrings = strings.APPLICANT.ACCESS_REQUEST
  const isUcc = type === 'ucc'
  const title = isUcc ? accessStrings.UCC_TITLE : accessStrings.LEXIS_TITLE
  const subject = isUcc ? accessStrings.UCC_SUBJECT : accessStrings.LEXIS_SUBJECT
  const descPrefix = isUcc
    ? accessStrings.UCC_DESCRIPTION_PREFIX
    : accessStrings.LEXIS_DESCRIPTION_PREFIX
  const descSuffix = isUcc
    ? accessStrings.UCC_DESCRIPTION_SUFFIX
    : accessStrings.LEXIS_DESCRIPTION_SUFFIX

  return (
    <Alert severity="info" className="mb-3">
      <div>{title}</div>
      <div>
        <strong>Subject:</strong> {subject}
      </div>
      <div>
        <strong>Description:</strong> {descPrefix}
        {clientName} (ID: {clientId}). User: {userEmail}. {descSuffix}
      </div>
      <div className="mt-2">
        <a href={accessStrings.SUPPORT_URL} target="_blank" rel="noopener noreferrer">
          {accessStrings.OPEN_SUPPORT}
        </a>
      </div>
    </Alert>
  )
}

export default AccessRequestAlert
